import { Navigate, Outlet } from "react-router-dom";
import { auth } from "../../../config/firebase";

function ProtectedRoute() {
  const user = auth.currentUser;

  if (!user) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
